export const PropositionOrientations = {
    ROW: 'row',
    COLUMN: 'column',
};
export const PropositionAlignments = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right',
};
export var PropositionTypes;
(function (PropositionTypes) {
    PropositionTypes["Header"] = "header";
    PropositionTypes["Footer"] = "footer";
    PropositionTypes["Catalog"] = "catalog";
    PropositionTypes["Product"] = "product";
    PropositionTypes["SubscriptionProduct"] = "subscriptionProduct";
    PropositionTypes["SubscriptionInformation"] = "subscriptionInformation";
    PropositionTypes["Service"] = "service";
    PropositionTypes["Cart"] = "cart";
    PropositionTypes["Home"] = "home";
})(PropositionTypes || (PropositionTypes = {}));
export var IconType;
(function (IconType) {
    IconType["Checkmark"] = "checkmark";
    IconType["Youtube"] = "youtube";
    IconType["Box"] = "box";
    IconType["Star"] = "star";
    IconType["CircleFacebook"] = "circleFacebook";
    IconType["CircleYoutube"] = "circleYoutube";
    IconType["SmileHappy"] = "smileHappy";
    IconType["TrustPilot"] = "trustpilot";
    IconType["Snowflake"] = "snowflake";
    IconType["FlamingSled"] = "flamingSled";
    IconType["Present"] = "present";
})(IconType || (IconType = {}));
export var DaySection;
(function (DaySection) {
    DaySection["WholeDay"] = "WholeDay";
    DaySection["Morning"] = "Morning";
    DaySection["Afternoon"] = "Afternoon";
    DaySection["Evening"] = "Evening";
})(DaySection || (DaySection = {}));
//# sourceMappingURL=types.js.map